<template>
	<div class="container-fluid">
		<h1 class="mb-4">{{ $t("reports") }}</h1>
		<div class="row">

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'REPORT_ALLSTUDENTS')">
				<div
					@click="selectStudent"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('progress-reports') }}</h3>
						<p class="mb-0">{{ $t('view-progress-reports-for-student') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'REPORT_ALLSTUDENTS') && $UserSession.hasPriv.call(this, 'REPORT_ANALYSIS')">
				<div
					@click="$router.push('/reports/aggregated')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('analysis-report') }}</h3>
						<p class="mb-0">{{ $t('view-progress-data-for-whole-student-cohort') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'REPORT_ALLSTUDENTS') && $UserSession.hasPriv.call(this, 'REPORT_INDIVIDUAL') && $config.hasModule('clinical')">
				<div
					@click="$router.push('/reports/activity')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('activity-reports') }}</h3>
						<p class="mb-0">{{ $t('view-activity-reports-for-student') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN') || $UserSession.hasPriv.call(this, 'ABSENCE_MANAGE')">
				<div
					@click="$router.push('/reports/attendance')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('attendance') }}</h3>
						<p class="mb-0">{{ $t('attendance-report') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN') || $UserSession.hasPriv.call(this, 'ABSENCE_MANAGE') || $UserSession.hasPriv.call(this, 'PLACEMENT_CHECK_ATTENDANCE')">
				<div
					@click="$router.push('/reports/signoff-anomalies')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('signoff-anomalies') }}</h3>
						<p class="mb-0">{{ $t('attendance-report') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'REPORT_ALLSTUDENTS') && $UserSession.hasPriv.call(this, 'REPORT_TERMREPORT')">
				<div
					@click="$router.push('/reports/saved/list')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('term-reports') }}</h3>
						<p class="mb-0">{{ $t('view-term-reports') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6" v-if="$UserSession.hasPriv.call(this, 'REPORT_MYTREATMENTSESSIONFEEDBACK') && $config.hasModule('clinical')">
				<div
					@click="$router.push('/feedback/studentfeedback')"
					class="list-group border-radius-2 no-border mb-3"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('treatment-session-feedback') }}</h3>
						<p class="mb-0">{{ $t('view-my-treatment-session-feedback-from-students') }}</p>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	methods: {
		selectStudent() {
			if(this.$UserSession.hasPriv.call(this, 'REPORT_ALLSTUDENTS')){
				const self = this;
				this.$users.getStudents.call(this).then(students => {
					this.$store.commit("openModal", {
						type: "selector",
						title: this.$t("select-a-student"),
						selectCallback: function(selection) {
							self.$store.commit("closeModal");
							self.$router.push(`/reports/report/progress/${selection.id}`);
						},
						selected: [
						],
						data: students,
						captionKey: "displayName",
                        subcaptionKey: "studentid",
						studentSearchFilters: true
					});
				});
			} else {
				this.$router.push('/reports/report/progress/');
			}
		}
	}
};
</script>
